import A from './types';

const initialState = {
  loading: true,
  error: false,
  lists: [],
};

const joinData = (data) => {
  const id = data[2];
  data = data.slice(0, 2);
  let newArr = data.map((i, idx) => i.items);
  const t = {};
  let loads = newArr.concat.apply([], newArr).filter(x => x.id === id ? false : t[x.id] ? false : t[x.id] = true).slice(0, 100);
  const compare = (key) => (obj1, obj2) => {
    var value1 = new Date(obj1[key]['date_local']);
    var value2 = new Date(obj2[key]['date_local']);
    return value2 - value1;
  }
  return loads.sort(compare('pickup'));
}

const reducer = (state, action) => {
  switch (action.type) {
    case A.DETAILS_LOADS_SEARCH: {
      if(action.pending){
        return {
          ...state,
          loading: true,
          error: false,
          lists: [],
        }
      }
      if(action.error){
        return {
          ...state,
          loading: false,
          error: true,
          lists: [],
        }
      }
      return {
        ...state,
        loading: false,
        error: false,
        lists: joinData(action.payload),
      }
    }
  }
  return null;
}


export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/loadDetails/reducer.js